const careerStages = [
  "enthusiastic",
  "aspirant",
  "experiment",
  "emerging",
  "promise",
  "sustainable",
  "localSuccess",
  "regionalSuccess",
  "nationalSuccess",
  "internationalSuccess",
  "icon",
];

export default careerStages;
